import { Button } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import RedoIcon from "@mui/icons-material/Redo";
import { useMainContext } from "../../../../../context/useMainContext";

export default function UndoButton() {
  const { undoState, handleUndoRedo } = useMainContext();

  if (!undoState.undoFunction) {
    return null;
  }

  return (
    <Button
      variant="contained"
      onClick={handleUndoRedo}
      size="small"
      startIcon={undoState.isUndoPerformed ? <RedoIcon /> : <ReplayIcon />}
      color="info"
      title={undoState.isUndoPerformed ? "Redo (Ctrl+Shift+Z)" : "Undo (Ctrl+Z)"}
      disabled={undoState.isProcessing}
      disableElevation
    >
      {undoState.isUndoPerformed ? "Redo" : `${undoState.action ? `${undoState.action}.` : ""} Undo`}
    </Button>
  );
}
